import styled, { css } from "styled-components";
import { IProps } from ".";
import {
  BUTTON_HEIGHT,
  FONT_SIZE,
  HEIGHT_SELECTION_INPUT,
  TEXT_SCALE_PROPS,
} from "@lhd/constants";
import { DISPLAY_SIZES } from "@lhd/types";

const getDisplaySize = (displaySize?: TEXT_SCALE_PROPS["displaySize"]) =>
  displaySize || DISPLAY_SIZES.SMALL;

interface PaginationStylesProps {
  justify: IProps["justify"];
  showPageChanger: boolean;
  displaySize: TEXT_SCALE_PROPS["displaySize"];
  $isDefaultValue?: boolean;
}

export const Styles = styled.div<PaginationStylesProps>`
  display: flex;
  justify-content: ${(props) => props.justify || "end"};
  align-items: center;
  gap: 4px;
  flex-shrink: 0;
  line-height: 1;

  ${({ displaySize }) => {
    const size = getDisplaySize(displaySize);
    const fontSize = FONT_SIZE[size];

    return css`
      font-size: ${fontSize};
      font-weight: 700;

      > b {
        font-size: ${fontSize};
        font-weight: 700;
        color: #222;
        white-space: nowrap;
        flex-shrink: 0;
      }
    `;
  }}

  .ant-pagination {
    display: flex;
    align-items: center;
    gap: 4px;
    margin: 0 !important;

    li {
      order: 2;
      display: ${({ showPageChanger }) =>
        showPageChanger ? "block" : "none !important"};
      margin: 0 !important;

      &.ant-pagination-options {
        display: block !important;
        order: 1;
        margin: 0 !important;
        margin-right: 0;
        .ant-select .ant-select-arrow {
          background-color: #fff;
          svg {
            fill: #000;
          }
        }
        .ant-select-selector {
          border: none;
        }
      }
    }

    ${({ displaySize }) => {
      const size = getDisplaySize(displaySize);
      const fontSize = FONT_SIZE[size];
      const selectHeight = HEIGHT_SELECTION_INPUT[size];
      const pageItemSize = BUTTON_HEIGHT[size];

      return css`
        .ant-pagination-item,
        .ant-pagination-prev,
        .ant-pagination-next,
        .ant-pagination-jump-prev,
        .ant-pagination-jump-next {
          min-width: ${pageItemSize}px;
          height: ${pageItemSize}px;
          line-height: ${pageItemSize - 2}px;
        }

        .ant-pagination-item {
          border-radius: 50% !important;
          display: flex;
          align-items: center;
          justify-content: center;
          border: 1.5px solid #d9d9d9;
          font-size: ${fontSize};

          a {
            font-size: ${fontSize};
            font-weight: 700;
            color: #222;
          }
        }

        .ant-pagination-item-active {
          background: #174a83;
          border-color: #174a83;

          a {
            color: #fff !important;
          }
        }

        .ant-pagination-prev,
        .ant-pagination-next {
          display: flex;
          align-items: center;
          justify-content: center;

          .ant-pagination-item-link {
            font-size: ${fontSize};
            border: none !important;
            display: flex;
            align-items: center;
            justify-content: center;
            width: ${pageItemSize}px;
            height: ${pageItemSize}px;
            min-width: ${pageItemSize}px;
          }
        }

        .ant-pagination-jump-prev,
        .ant-pagination-jump-next {
          .ant-pagination-item-container .ant-pagination-item-link-icon {
            color: #174a83;
            font-size: ${fontSize};
          }
        }

        .ant-pagination-options .ant-select {
          min-width: ${size === "small"
            ? "45px"
            : size === "medium"
            ? "52px"
            : "58px"};
          height: ${selectHeight}px !important;
          font-size: ${fontSize};
          font-weight: 700;

          &.ant-select-open,
          &.ant-select-focused {
            height: ${selectHeight}px !important;
          }

          .ant-select-selector {
            height: ${selectHeight}px !important;
            min-height: ${selectHeight}px !important;
            max-height: ${selectHeight}px !important;
            padding: 0 !important;
            border-width: 1px !important;
            box-sizing: border-box !important;
            box-shadow: none !important;
            display: flex;
            align-items: center;
          }

          &.ant-select-open .ant-select-selector,
          &.ant-select-focused .ant-select-selector {
            height: ${selectHeight}px !important;
            min-height: ${selectHeight}px !important;
            max-height: ${selectHeight}px !important;
            box-shadow: none !important;
          }

          .ant-select-selection-item {
            font-size: ${fontSize} !important;
            font-weight: 700;
            line-height: 1 !important;
            display: flex;
            align-items: center;
            padding-right: 0;
          }

          .ant-select-arrow {
            background-color: ${(props: PaginationStylesProps) =>
              props.$isDefaultValue !== false ? "#aac8f3" : "#1890FF"};
            color: #fff;
            svg {
              fill: #fff;
            }
            width: 20px;
            height: 100% !important;
            top: 50% !important;
            right: 0;
            margin-top: 0 !important;
            transform: translateY(-50%);
            display: flex;
            align-items: center;
            justify-content: center;
            border-top-right-radius: 4px;
            border-bottom-right-radius: 4px;
            pointer-events: none;
          }
        }
      `;
    }}
  }
`;
